
export enum ComparadorEnum {
    MAYOR_IGUAL_QUE = 'MAYOR_IGUAL_QUE',
    MENOR_IGUAL_QUE = 'MENOR_IGUAL_QUE'
}